const SYSTEM_ALERT_ACCEPTED_KEY = 'systemAlertAccepted';
const SYSTEM_ALERT_TTL_MS = 60 * 60 * 1000;
const SYSTEM_ALERT_POLL_MS = 5 * 60 * 1000;
const SYSTEM_ALERT_ENDPOINT = '/api/v1/system-alerts';

const activeAlerts = new Set();

const logDebug = (...args) => {
    window.Taskello?.debugLog?.('system_alerts', ...args);
};

const getAcceptedAlerts = () => {
    try {
        const stored = window.localStorage.getItem(SYSTEM_ALERT_ACCEPTED_KEY);

        if (!stored) {
            return {};
        }

        const parsed = JSON.parse(stored);
        return parsed && typeof parsed === 'object' ? parsed : {};
    } catch {
        return {};
    }
};

const rememberAcceptedAlert = (key) => {
    const accepted = getAcceptedAlerts();
    accepted[key] = Date.now();

    try {
        window.localStorage.setItem(SYSTEM_ALERT_ACCEPTED_KEY, JSON.stringify(accepted));
    } catch {
    }
};

const getAlertKey = (alert) => {
    const name = alert?.name || '';
    const updated = alert?.updated || '';
    const type = alert?.type || '';

    return `${type}::${name}::${updated}`;
};

const shouldShowAlert = (key) => {
    const acceptedAt = getAcceptedAlerts()[key];

    if (!acceptedAt) {
        return true;
    }

    return Date.now() - acceptedAt >= SYSTEM_ALERT_TTL_MS;
};

const showAlert = (alert) => {
    if (!alert || typeof alert !== 'object') {
        return;
    }

    const key = getAlertKey(alert);

    if (!shouldShowAlert(key) || activeAlerts.has(key)) {
        return;
    }

    activeAlerts.add(key);

    const message = alert.body || '';
    const title = alert.name || 'Alert systemowy';
    const type = alert.type || 'warning';

    window.taskello?.showToast?.(message, type, {
        header: title,
        closable: true,
        autoHide: false,
        onClose: () => {
            rememberAcceptedAlert(key);
            activeAlerts.delete(key);
        }
    });
};

const fetchSystemAlerts = () => {
    return window.fetch(SYSTEM_ALERT_ENDPOINT, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
            Accept: 'application/json'
        }
    })
        .then((response) => {
            if (!response.ok) {
                throw new Error(`System alert fetch failed: ${response.status}`);
            }

            return response.json();
        })
        .then((data) => {
            const contents = Array.isArray(data?.data) ? data.data : [];
            contents.forEach((alert) => {
                showAlert(alert);
            });
        })
        .catch((error) => {
            logDebug('fetch error', error);
        });
};

const initSystemAlerts = () => {
    logDebug('init');

    fetchSystemAlerts();
    window.setInterval(fetchSystemAlerts, SYSTEM_ALERT_POLL_MS);
};

if (window.Taskello?.config?.isAuth) {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initSystemAlerts, { once: true });
    } else {
        initSystemAlerts();
    }
}
